import React from 'react';
import { Icon } from '@chakra-ui/react';

export const Magnifier = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.096 15.33l-4.754-5.188A5.958 5.958 0 0012.002 6c0-1.602-.624-3.11-1.758-4.242A5.964 5.964 0 006.002 0C4.4 0 2.892.624 1.76 1.758A5.963 5.963 0 00.002 6c0 1.602.624 3.11 1.758 4.242A5.963 5.963 0 006.002 12c1.38 0 2.69-.463 3.75-1.316l4.755 5.186a.398.398 0 00.565.025.4.4 0 00.025-.565zM.801 6c0-2.867 2.333-5.2 5.2-5.2s5.2 2.333 5.2 5.2-2.333 5.2-5.2 5.2A5.206 5.206 0 01.801 6z"
        fill="#B3B3B3"
      />
    </Icon>
  );
};
